import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';
import { ThemeProvider } from './components/ThemeProvider';

// Check if there's a saved theme preference
const savedTheme = localStorage.getItem('theme');

// If no saved preference, default to light mode
if (!savedTheme) {
  localStorage.setItem('theme', 'light');
  document.documentElement.classList.add('light');
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="light" storageKey="theme">
      <App />
    </ThemeProvider>
  </React.StrictMode>
);